import type { PaymentTerminalV2 } from "@lemmonhq/types";

const NS = "settings.terminals";

export type TerminalStatusTone = "success" | "warning" | "neutral";

/** Label key + tone for a terminal's stored status. */
export const getTerminalStatus = (
  status: string | null | undefined,
): { labelKey: string; tone: TerminalStatusTone } => {
  switch (status) {
    case "paired":
      return { labelKey: `${NS}.paired`, tone: "success" };
    case "connected":
      return { labelKey: `${NS}.connected`, tone: "success" };
    case "not_connected":
      return { labelKey: `${NS}.not_connected`, tone: "warning" };
    default:
      return { labelKey: `${NS}.unknown_status`, tone: "neutral" };
  }
};

export const statusBadgeClass: Record<TerminalStatusTone, string> = {
  success: "badge badge-success badge-outline",
  warning: "badge badge-warning badge-outline",
  neutral: "badge badge-outline",
};

/**
 * The identifier staff recognise the device by: serial number for paired
 * hardware (Payrexx/Adyen/Stripe), terminal ID for Nakka.
 */
export const getTerminalIdentifier = (
  terminal: PaymentTerminalV2,
): { labelKey: string; value: string } | null => {
  if (terminal.serial_number) {
    return { labelKey: `${NS}.serial`, value: terminal.serial_number };
  }
  if (terminal.terminal_id) {
    return { labelKey: `${NS}.terminal_id_label`, value: String(terminal.terminal_id) };
  }
  return null;
};

/** tRPC / fetch errors carry a human-readable message; fall back otherwise. */
export const errorMessage = (error: unknown, fallback: string) =>
  error instanceof Error && error.message ? error.message : fallback;

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
